import { render, staticRenderFns } from "./EdInputSwitch.vue?vue&type=template&id=78ad62fa&"
import script from "./EdInputSwitch.vue?vue&type=script&lang=js&"
export * from "./EdInputSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports